import type { DetailedHTMLProps, InputHTMLAttributes, ReactNode } from 'react'

import clsx from 'clsx'

import '@hotmart/cosmos/dist/form/form.css'
import '@hotmart/cosmos/dist/form/input-custom.css'
import '@hotmart/cosmos/dist/form/input-radio.css'
import Label from '../label'

export type RadioProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  name: string
  id: string
  'aria-label'?: string
  label?: ReactNode
}

const Radio = ({ name, id, label = ' ', className = '', ...rest }: RadioProps) => {
  const classes = clsx('hot-form--custom hot-form--radio', className)

  return (
    <div className={classes}>
      <input {...rest} className='hot-form__input' id={id} name={name} type='radio' />
      <Label htmlFor={id}>{label}</Label>
    </div>
  )
}

export default Radio
